module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraLight.87405d1.woff";